import { Button } from '@/app/common/components/Button'
import { cn } from '@/common/utilities.ts'
import { StoreScope } from '@/app/pages/marketplace/utils'
import { useTranslation } from 'react-i18next'

const STORE_SCOPE_OPTIONS: { value: StoreScope; labelKey: string }[] = [
  { value: 'my_schools', labelKey: 'my_schools' },
  { value: 'all', labelKey: 'all_storefronts' },
]

type Props = {
  value: StoreScope
  onChange: (scope: StoreScope) => void
}

export default function StoreScopeToggle({ value, onChange }: Props) {
  const { t: translate } = useTranslation()

  return (
    <div
      role="group"
      aria-label={translate('store_scope_label')}
      className="inline-flex rounded-md shadow-sm"
    >
      {STORE_SCOPE_OPTIONS.map((option, index) => {
        const isSelected = value === option.value

        return (
          <Button
            key={option.value}
            type="button"
            size="md"
            variant={isSelected ? 'primary' : 'outline'}
            aria-pressed={isSelected}
            onClick={() => onChange(option.value)}
            className={cn(
              'whitespace-nowrap shadow-none',
              index === 0 ? 'rounded-r-none' : '-ml-px rounded-l-none'
            )}
          >
            {translate(option.labelKey)}
          </Button>
        )
      })}
    </div>
  )
}
